import React, { useContext, useState, useEffect } from "react";
import Fade from "react-reveal/Fade";
import { Container, Row, Col } from "react-bootstrap";
import Title from "components/booth/title";
// import AboutImg from '../Image/AboutImg';
import PortfolioContext from "../../context/context";
import Quiz from "components/chongdongyeon/quiz";
import hunterImg from "../../img/hunter.png";
import box from "../../img/box.png";
import testbg from "../../img/testbg.jpeg";
const getCntCorrect = () => {
  let local = JSON.parse(localStorage.getItem("qa"));
  if (local === null) {
    return 0;
  }
  let cnt = 0;
  for (let i = 0; i < local.length; i++) {
    if (local[i] !== "") {
      cnt++;
    }
  }
  return cnt;
};
const hunterment = [
  "이번주에도 잘 찾아왔군! 여기 단서를 줄테니 단서를 보고 각 Stage에 해당하는 분과에 소속된 동아리 부스에서 답을 찾아 퀴즈를 풀어봐! 자세한 내용은 아래 이벤트 소개를 참고하도록!",
  "잠에 들면 안돼!! 함정에 빠지지 않도록 조심하도록!",
  "거기를 걷다보면 자신도 모르게 바보가 될 수 있어!. 얼른 탈출해야해!!",
  "희망과 기대가 가득찬 공간이야! 지치지 않게 조금 쉬어가도록~",
  "그 버스를 타면 지옥이 무엇인지 알 수 있지... 이겨낼 수 있을거야 힘내!!",
  "대부분의 사람들이 여기서 포기하고 가지... 하지만 너는 다를거라 생각한다!! ",
  "드디어 마지막 관문인 비밀의 문이군!! 마지막 퀴즈도 성공해서 보물을 찾아봐!! 엄청난 보물이 너를 기다리고 있어!",
  "정말 해냈군!! 해낼거라 믿었있어!! 명지보물섬의 엄청나고 신비한 보물이 뭔지 얼른 확인해보라구!! (참여해주신 모든 분들 정말 감사합니다.)",
];

const About = () => {
  const { departmentObj } = useContext(PortfolioContext);
  const { information, information_m, key } = departmentObj;
  const [isDesktop, setIsDesktop] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [textIdx, setTextIdx] = useState(getCntCorrect());
  useEffect(() => {
    if (window.innerWidth > 769) {
      setIsDesktop(true);
      setIsMobile(false);
    } else {
      setIsMobile(true);
      setIsDesktop(false);
    }
  }, []);

  return (
    <section id="about" className={key}>
      <Container>
        <Title title="QUEST" />
        {/* <Quiz /> */}
        <Row className="about-wrapper">
          <Col md={6} sm={12}>
            <Fade bottom duration={1000} delay={600} distance="30px">
              <Quiz />
              <div>*동일 디바이스 동일 브라우저 사용시 결과가 기록됩니다.</div>
              <div>
                *브라우저 방문기록, 로컬 저장소, 캐시 삭제시 기록이 사라질 수
                있습니다.
              </div>
            </Fade>
          </Col>
          <Col md={6} sm={12}>
            <Fade
              left={isDesktop}
              bottom={isMobile}
              duration={1000}
              delay={1000}
              distance="30px"
            >
              <div className="relativeDiv">
                <img id="hunter" src={hunterImg} />
                {/* <img id="box" src={box} /> */}
                <span id={`hunterMent${textIdx}`} className="hunterMent">
                  {hunterment[textIdx]}
                </span>
                <div id="passnumArr">
                  <div className="passnumber"></div>
                  <div className="passnumber"></div>
                  <div className="passnumber"></div>
                  <div className="passnumber"></div>
                  <div className="passnumber"></div>
                  <div className="passnumber"></div>
                  <div className="passnumber"></div>
                </div>
              </div>
            </Fade>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default About;
